<script lang="ts">
	import { storefront_prefix } from 'shared/var'
	import { get_related, type get_map } from 'shared/json_api/get_related'

	export let storefront_menu_items: ResourceTypes[`storefront_menu_item`][]
	export let included_map: ReturnType<typeof get_map>
	export let active_menu_id: string | null = null
	export let menu_href_prefix: string

	const breadcrumbs = (menu_item: ResourceTypes[`storefront_menu_item`] | undefined): ResourceTypes[`storefront_menu_item`][] => {
		if (!menu_item) { return [] }
		const parent = storefront_menu_items.find(c => c.id === menu_item.relationships.parent_storefront_menu_item?.data?.id)
		return parent ? [ ...breadcrumbs(parent), menu_item ] : [ menu_item ]
	}

	$: menu_item_chain = breadcrumbs(storefront_menu_items.find(item => item.id === active_menu_id))
</script>

<div class="menu">
	{#each storefront_menu_items.filter(item => !item.relationships.parent_storefront_menu_item?.data?.id) as item}
		{@const sub_items = storefront_menu_items.filter(sub_item => sub_item.relationships.parent_storefront_menu_item?.data?.id === item.id)}
		{@const category = get_related(included_map, item, `storefront_product_category`)}
		{@const name = item.attributes.name ? item.attributes.name : category?.attributes.name}
		{@const active = menu_item_chain.some(i => i.id === item.id)}
		{@const href = active
			? `#`
			: sub_items.length
				? `${ menu_href_prefix }${ item.id }`
				: category
					? `${ storefront_prefix }/product-category/${ category.attributes.slug }`
					: item.attributes.href}

		<a {href} class:active>
			{name}
			{#if sub_items.length}
				<svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 16 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9l6 6 6-6"/></svg>
			{/if}
		</a>
	{/each}
</div>

<style>
	.menu {
		display: flex;
		gap: 5px;
	}

	a {
		color: #fff;
		padding: 0 10px;
		line-height: 38px;
		text-decoration: none;
		font-size: 1rem;
		font-weight: 500;
		display: flex;
		align-items: center;
		border-bottom: 2px solid transparent;
		gap: 5px;
	}

	a svg {
		transition: transform 0.2s ease-in-out;
		margin-top: 2px;
	}

	a.active {
		border-bottom-color: #fff;
	}

	a.active svg {
		transform: rotate(-180deg);
	}

	a:hover {
		text-decoration: none;
	}
</style>
